const VerificationValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const verificationFormRequiredFields: string[] = [
    'code',
  ];

  verificationFormRequiredFields.forEach((field: string): void => {
    if ((!values[field] || !values[field].toString().trim()) && values[field] !== null) {
      errors[field] = 'Required';
    }
  });

  return errors;
};

export default VerificationValidator;
